export type DriverLang = 'ru' | 'kk';

const LANG_KEY = 'driverLang';

export function getDriverLang(): DriverLang {
  try {
    const raw = localStorage.getItem(LANG_KEY);
    return raw === 'kk' ? 'kk' : 'ru';
  } catch {
    return 'ru';
  }
}

export function setDriverLang(lang: DriverLang) {
  localStorage.setItem(LANG_KEY, lang);
}

export const TG_SUPPORT = 'https://t.me/cashalot_edo';
export const MONTHLY_SUBSCRIPTION = 1000;

export const COPY = {
  ru: {
    menu: 'Меню',
    documents: 'Документы',
    toSign: 'На подпись',
    signed: 'Подписанные',
    signAll: 'Подписать',
    signing: 'Подписание…',
    refresh: 'Обновить',
    loading: 'Загрузка…',
    emptyToSign: 'Нет документов, ожидающих вашей подписи',
    emptySigned: 'Нет подписанных документов',
    openEgov: 'Открыть eGov Mobile',
    signHint: 'Нажмите «Открыть eGov Mobile» и подпишите документы',
    preparing: 'Подготовка…',
    buyer: 'Заказчик',
    seller: 'Исполнитель',
    source: 'Источник',
    status: 'Статус',
    amount: 'Сумма',
    period: 'Период',
    park: 'Парк',
    yandex: 'Яндекс',
    download: 'Скачать',
    downloading: 'Скачивание…',
    signOne: 'Подписать (eGov Mobile)',
    goingEgov: 'Переход в eGov…',
    pdfLoading: 'Загрузка документа…',
    pdfMissing: 'PDF для этого документа пока недоступен',
    document: 'Документ',
    profile: 'Профиль',
    fio: 'ФИО',
    language: 'Язык',
    russian: 'Русский',
    kazakh: 'Қазақша',
    balance: 'Подписка',
    subscriptionMonth: 'Подписка на месяц',
    tariff: 'Тариф',
    tariffName: 'Прямой самозанятый',
    tariffPay: 'Оплата',
    tariffPerMonth: 'в месяц',
    documentsCount: 'Количество документов',
    documentsUnlimited: 'Неограничено',
    mainAccount: 'Основной счёт',
    topUp: 'Пополнить',
    topUpHistory: 'История пополнений',
    noTopups: 'Пополнений пока нет',
    payTitle: 'Подписка',
    payTabCard: 'Карта',
    payTabQr: 'QR',
    cardNumber: 'Номер карты',
    cardExpiry: 'Срок',
    cardCvc: 'CVV',
    cardHolder: 'Имя на карте',
    paySent: 'Платёж отправлен',
    payChoose: 'Выберите способ оплаты',
    payHomeCredit: 'Эквайринг через Банк HomeCreditBank',
    payKaspi: 'Оплата с помощью Kaspi',
    payHomeHint: 'Оплатить банковской картой',
    payKaspiHint: 'Через мобильное приложение',
    subscriptionCancelled: 'Подписка отменена',
    payHosted: 'Оплата откроется на странице банка. Данные карты на нашем сайте не вводятся.',
    payQrHint: 'Отсканируйте QR в приложении Kaspi или нажмите «Оплатить».',
    payError: 'Не удалось открыть оплату',
    payOk: 'Оплата прошла, подписка будет подтверждена в течение минуты.',
    payFail: 'Банк отклонил оплату. Попробуйте ещё раз.',
    payCancel: 'Оплата отменена.',
    parkPaysEdo: 'В этом месяце оплату ЭДО вносит парк',
    selfPaysEdo: 'В этом месяце оплату ЭДО вносите вы',
    payBeforeSign: 'Чтобы подписать АВР, сначала оплатите ЭДО за этот период',
    goPay: 'Оплатить',
    kaspiPay: 'Оплата в Kaspi.kz',
    kaspiHint: 'Нажмите «Оплатить» — откроется Kaspi с суммой и вашим ИИН.',
    kaspiAccount: 'Лицевой счёт (ИИН)',
    dueAmount: 'К оплате',
    paid: 'Оплачено',
    overdue: 'Просрочено',
    invoiced: 'Счёт выставлен',
    dueBy: 'Оплатить до',
    help: 'Помощь',
    support: 'Техподдержка',
    logout: 'Выйти',
    back: 'Назад',
    count: 'шт.',
    active: 'Активен',
    selfemployed: 'Самозанятый',
    working: 'Работает',
    notWorking: 'Не работает',
    fired: 'Уволен',
    loginLead:
      'Войдите через приложение eGov Mobile — подтвердите вход своей электронной подписью. ИИН определяется из сертификата.',
    loginBtn: 'Войти через eGov Mobile',
    loginPreparing: 'Подготовка…',
    loginQrHint:
      'Откроется eGov Mobile — подпишите «Подтверждение входа» и вернитесь в браузер.',
    loginIosHint: 'Открывайте сайт в Safari, не во встроенном браузере Telegram или Instagram.',
    loginCancel: 'Отмена',
    loginExpired: 'Время входа истекло. Попробуйте снова.',
    loginCanceled: 'Вход отменён.',
    loginFailed: 'Не удалось начать вход',
    loginDemoLead: 'Тестовый вход для показа оплаты, без электронной подписи.',
    loginDemoPlaceholder: 'Код',
    loginDemoBtn: 'Войти как тестовый водитель',
    loginDemoFailed: 'Неверный код',
    offerTitle: 'Публичная оферта',
    offerAccept: 'Продолжая, вы соглашаетесь с условиями публичной оферты и политики конфиденциальности.',
    offerLink: 'Публичной оферты',
    offerClose: 'Закрыть',
    legalTitle: 'Сведения о сервисе',
    legalDocs: [
      {
        id: 'offer',
        title: 'Договор оферты',
        sections: [
          {
            title: '1. Общие положения',
            text: 'Настоящая публичная оферта (далее — Оферта) определяет условия оказания услуг электронного документооборота Cashalot ЭДО (далее — Сервис, Предприятие) держателю карточки (далее — Пользователь). Акцепт Оферты — вход в кабинет и/или оплата подписки.',
          },
          {
            title: '2. Предмет',
            text: 'Предприятие предоставляет Пользователю доступ к кабинету водителя: просмотр и подписание электронных документов (АВР и иных) и подписку тарифа «Прямой самозанятый». Услуга оказывается дистанционно, в электронной форме.',
          },
          {
            title: '3. Стоимость и расчёты',
            text: 'Стоимость подписки — 1 000 (одна тысяча) тенге в месяц, включая НДС, если НДС применяется по законодательству РК. Расходов на физическую поставку нет. Оплата банковской картой или по QR.',
          },
          {
            title: '4. Порядок предоставления услуги',
            text: 'Доступ к Сервису предоставляется сразу после успешной оплаты, круглосуточно, через сайт кабинета. Срок оказания — календарный месяц, на который оплачена подписка.',
          },
          {
            title: '5. Возврат и претензии',
            text: 'Порядок возврата денег, замены при некачественном оказании услуги, адреса и телефоны Предприятия опубликованы отдельными документами на этой странице.',
          },
        ],
      },
      {
        id: 'privacy',
        title: 'Политика конфиденциальности',
        sections: [
          {
            title: '1. Какие данные обрабатываются',
            text: 'Предприятие обрабатывает ИИН, ФИО, номер телефона, данные входа, сведения о подписке и платеже в объёме, необходимом для оказания услуги и исполнения требований законодательства Республики Казахстан.',
          },
          {
            title: '2. Цели обработки',
            text: 'Идентификация Пользователя, предоставление доступа к кабинету, приём оплаты, подписание электронных документов, поддержка и исполнение обязанностей по бухгалтерскому и налоговому учёту.',
          },
          {
            title: '3. Передача и защита',
            text: 'Данные не продаются. Они могут передаваться платёжному провайдеру, eGov Mobile и иным уполномоченным лицам только для оказания услуги. Доступ ограничен, соединение защищается.',
          },
          {
            title: '4. Права Пользователя',
            text: 'Пользователь вправе запросить сведения об обработке данных, их исправление или удаление, если это не противоречит закону. Запрос направляется по контактам Предприятия.',
          },
        ],
      },
      {
        id: 'refund',
        title: 'Порядок возврата услуги и денег',
        sections: [
          {
            title: '1. Характер услуги',
            text: 'Сервис — электронная услуга. Физический товар не передаётся, возврат товара в смысле розничной торговли не применяется. Возвращается неиспользованная оплата за подписку.',
          },
          {
            title: '2. Как заявить о возврате',
            text: 'Пользователь направляет заявление по телефону +7 700 131 30 25 или на почту 2303@313.kz, указывает ИИН, дату платежа и причину. Предприятие рассматривает заявление в течение 5 рабочих дней.',
          },
          {
            title: '3. Срок возврата денег',
            text: 'Деньги за неиспользованный период возвращаются на ту же карту или иным способом оплаты в течение 10 рабочих дней после одобрения заявления. Комиссия банка-эмитента, если она удержана банком, не компенсируется Предприятием.',
          },
        ],
      },
      {
        id: 'delivery',
        title: 'Порядок и сроки предоставления услуги',
        sections: [
          {
            title: '1. Способ предоставления',
            text: 'Услуга предоставляется дистанционно в кабинете водителя на сайте Сервиса. Физическая поставка товара, доставка курьером и почтовая пересылка не осуществляются.',
          },
          {
            title: '2. Срок',
            text: 'Доступ открывается сразу после подтверждения оплаты. Подписка действует один календарный месяц. Количество документов в тарифе «Прямой самозанятый» не ограничено.',
          },
        ],
      },
      {
        id: 'replace',
        title: 'Порядок замены при некачественной услуге',
        sections: [
          {
            title: '1. Что считается недостатком',
            text: 'Недостаток — невозможность войти в кабинет, оплатить подписку или получить доступ к документам по вине Предприятия при действующей оплаченной подписке.',
          },
          {
            title: '2. Замена (восстановление)',
            text: 'По обращению Пользователя Предприятие восстанавливает доступ в течение 1 рабочего дня. Если восстановить услугу нельзя, Пользователь вправе получить возврат денег в порядке, указанном в документе о возврате.',
          },
        ],
      },
      {
        id: 'price',
        title: 'Стоимость услуг, включая НДС',
        sections: [
          {
            title: '1. Тариф',
            text: 'Тариф «Прямой самозанятый»: 1 000 (одна тысяча) тенге в месяц. Цена включает НДС, если НДС применяется. Расходов на поставку нет. Количество документов не ограничено.',
          },
          {
            title: '2. Иные платежи',
            text: 'Дополнительная плата за вход, подписание документов и хранение в рамках тарифа не взимается. Банк Пользователя может удерживать собственную комиссию — она не входит в цену Сервиса.',
          },
        ],
      },
      {
        id: 'contacts',
        title: 'Адрес и телефоны Предприятия',
        sections: [
          {
            title: '1. Предприятие',
            text: 'Cashalot ЭДО. Сайт: https://edo.cashalot.kz. Кабинет водителя: https://edo.cashalot.kz/driver.',
          },
          {
            title: '2. Почтовый, юридический и фактический адрес',
            text: 'Республика Казахстан, г. Алматы, Медеуский район, улица Митина, дом 4.',
          },
          {
            title: '3. Контактные телефоны и связь',
            text: 'Телефон: +7 700 131 30 25. Почта: 2303@313.kz. Telegram: https://t.me/cashalot_edo.',
          },
        ],
      },
    ],
    faq: [
      {
        q: 'Как подписать документы?',
        a: 'Откройте вкладку «На подпись» и нажмите «Подписать». Подпись проходит в приложении eGov Mobile.',
      },
      {
        q: 'Не открывается eGov Mobile',
        a: 'Откройте сайт в Safari (iPhone) или Chrome. Не используйте встроенный браузер Telegram или Instagram.',
      },
      {
        q: 'Где найти подписанные документы?',
        a: 'Во вкладке «Подписанные». Нажмите на карточку, чтобы открыть детали и PDF.',
      },
      {
        q: 'Как скачать документ?',
        a: 'Откройте карточку документа и нажмите «Скачать».',
      },
      {
        q: 'Документ просрочен — что делать?',
        a: 'Подпишите его как можно скорее. Если не получается — напишите в техподдержку.',
      },
    ],
  },
  kk: {
    menu: 'Мәзір',
    documents: 'Құжаттар',
    toSign: 'Қол қоюға',
    signed: 'Қол қойылған',
    signAll: 'Қол қою',
    signing: 'Қол қойылуда…',
    refresh: 'Жаңарту',
    loading: 'Жүктелуде…',
    emptyToSign: 'Қол қоюды күтетін құжаттар жоқ',
    emptySigned: 'Қол қойылған құжаттар жоқ',
    openEgov: 'eGov Mobile ашу',
    signHint: '«eGov Mobile ашу» батырмасын басып, құжаттарға қол қойыңыз',
    preparing: 'Дайындалуда…',
    buyer: 'Тапсырыс беруші',
    seller: 'Орындаушы',
    source: 'Көз',
    status: 'Мәртебе',
    amount: 'Сома',
    period: 'Кезең',
    park: 'Парк',
    yandex: 'Яндекс',
    download: 'Жүктеу',
    downloading: 'Жүктелуде…',
    signOne: 'Қол қою (eGov Mobile)',
    goingEgov: 'eGov-қа өту…',
    pdfLoading: 'Құжат жүктелуде…',
    pdfMissing: 'Бұл құжаттың PDF файлы әзірге жоқ',
    document: 'Құжат',
    profile: 'Профиль',
    fio: 'ТАӘ',
    language: 'Тіл',
    russian: 'Русский',
    kazakh: 'Қазақша',
    balance: 'Жазылым',
    subscriptionMonth: 'Айлық жазылым',
    tariff: 'Тариф',
    tariffName: 'Тікелей өзін-өзі жұмыспен қамтыған',
    tariffPay: 'Төлем',
    tariffPerMonth: 'айына',
    documentsCount: 'Құжаттар саны',
    documentsUnlimited: 'Шектеусіз',
    mainAccount: 'Негізгі шот',
    topUp: 'Толықтыру',
    topUpHistory: 'Толықтыру тарихы',
    noTopups: 'Толықтырулар әлі жоқ',
    payTitle: 'Жазылым',
    payTabCard: 'Карта',
    payTabQr: 'QR',
    cardNumber: 'Карта нөмірі',
    cardExpiry: 'Мерзімі',
    cardCvc: 'CVV',
    cardHolder: 'Картадағы аты',
    paySent: 'Төлем жіберілді',
    payChoose: 'Төлем тәсілін таңдаңыз',
    payHomeCredit: 'HomeCreditBank арқылы эквайринг',
    payKaspi: 'Kaspi арқылы төлеу',
    payHomeHint: 'Банк картасымен төлеу',
    payKaspiHint: 'Мобильді қосымша арқылы',
    subscriptionCancelled: 'Жазылым тоқтатылды',
    payHosted: 'Төлем банк бетінде ашылады. Карта деректері біздің сайтта енгізілмейді.',
    payQrHint: 'QR-ды Kaspi қосымшасында сканерлеңіз немесе «Төлеу» басыңыз.',
    payError: 'Төлемді ашу мүмкін болмады',
    payOk: 'Төлем өтті, жазылым бір минут ішінде расталады.',
    payFail: 'Банк төлемді қабылдамады. Қайта көріңіз.',
    payCancel: 'Төлем тоқтатылды.',
    parkPaysEdo: 'Осы айда ЭДО төлемін парк төлейді',
    selfPaysEdo: 'Осы айда ЭДО төлемін сіз төлейсіз',
    payBeforeSign: 'АВР-ға қол қою үшін алдымен осы кезеңнің ЭДО төлемін төлеңіз',
    goPay: 'Төлеу',
    kaspiPay: 'Kaspi.kz арқылы төлеу',
    kaspiHint: '«Төлеу» басыңыз — Kaspi сома мен ЖСН-мен ашылады.',
    kaspiAccount: 'Жеке шот (ЖСН)',
    dueAmount: 'Төлемге',
    paid: 'Төленді',
    overdue: 'Мерзімі өтті',
    invoiced: 'Шот қойылды',
    dueBy: 'Төлеу мерзімі',
    help: 'Көмек',
    support: 'Техникалық қолдау',
    logout: 'Шығу',
    back: 'Артқа',
    count: 'дана',
    active: 'Белсенді',
    selfemployed: 'Өзін-өзі жұмыспен қамтыған',
    working: 'Жұмыс істейді',
    notWorking: 'Жұмыс істемейді',
    fired: 'Жұмыстан шығарылған',
    loginLead:
      'eGov Mobile қосымшасы арқылы кіріңіз — электрондық қолтаңбаңызбен кіруді растаңыз. ЖСН сертификаттан анықталады.',
    loginBtn: 'eGov Mobile арқылы кіру',
    loginPreparing: 'Дайындалуда…',
    loginQrHint:
      'eGov Mobile ашылады — «Кіруді растау» құжатына қол қойып, браузерге оралыңыз.',
    loginIosHint: 'Сайтты Safari-де ашыңыз, Telegram немесе Instagram ішіндегі браузерді қолданбаңыз.',
    loginCancel: 'Болдырмау',
    loginExpired: 'Кіру уақыты өтті. Қайта көріңіз.',
    loginCanceled: 'Кіру тоқтатылды.',
    loginFailed: 'Кіруді бастау мүмкін болмады',
    loginDemoLead: 'Төлемді көрсетуге арналған сынақ кіру, электрондық қолтаңбасыз.',
    loginDemoPlaceholder: 'Код',
    loginDemoBtn: 'Сынақ жүргізуші ретінде кіру',
    loginDemoFailed: 'Код қате',
    offerTitle: 'Жария оферта',
    offerAccept: 'Жалғастыра отырып, сіз жария оферта мен құпиялылық саясатымен келісесіз.',
    offerLink: 'Жария оферта шарттарымен',
    offerClose: 'Жабу',
    legalTitle: 'Сервис туралы мәліметтер',
    legalDocs: [
      {
        id: 'offer',
        title: 'Оферта шарты',
        sections: [
          {
            title: '1. Жалпы ережелер',
            text: 'Осы жария оферта (бұдан әрі — Оферта) Cashalot ЭДО электрондық құжат айналымы қызметін (бұдан әрі — Сервис, Кәсіпорын) карточка ұстаушыға (бұдан әрі — Пайдаланушы) көрсету шарттарын айқындайды. Офертаны акцепттеу — кабинетке кіру және/немесе жазылымды төлеу.',
          },
          {
            title: '2. Мәні',
            text: 'Кәсіпорын Пайдаланушыға жүргізуші кабинетіне қолжетімділік береді: электрондық құжаттарды (АВР және басқа) қарау мен қол қою және «Тікелей өзін-өзі жұмыспен қамтыған» тарифі бойынша жазылым. Қызмет қашықтан, электрондық нысанда көрсетіледі.',
          },
          {
            title: '3. Құны және есеп айырысу',
            text: 'Жазылым құны — айына 1 000 (бір мың) теңге, ҚҚС қолданылса, ҚҚС-ты қоса. Физикалық жеткізу шығыны жоқ. Төлем банк картасы немесе QR арқылы жүргізіледі.',
          },
          {
            title: '4. Қызметті ұсыну тәртібі',
            text: 'Сервиске қолжетімділік сәтті төлемнен кейін бірден, тәулік бойы кабинет сайты арқылы беріледі. Мерзімі — жазылым төленген күнтізбелік ай.',
          },
          {
            title: '5. Қайтару және шағымдар',
            text: 'Ақшаны қайтару, сапасыз қызмет кезіндегі ауыстыру, Кәсіпорынның мекенжайы мен телефондары осы беттегі жеке құжаттарда жарияланған.',
          },
        ],
      },
      {
        id: 'privacy',
        title: 'Құпиялылық саясаты',
        sections: [
          {
            title: '1. Қандай деректер өңделеді',
            text: 'Кәсіпорын ЖСН, ТАӘ, телефон нөмірі, кіру деректері, жазылым және төлем мәліметтерін Қазақстан Республикасының заңнамасына сәйкес қызмет көрсету үшін қажетті көлемде өңдейді.',
          },
          {
            title: '2. Өңдеу мақсаттары',
            text: 'Пайдаланушыны сәйкестендіру, кабинетке қолжетімділік, төлемді қабылдау, электрондық құжаттарға қол қою, қолдау, бухгалтерлік және салықтық есеп міндеттерін орындау.',
          },
          {
            title: '3. Беру және қорғау',
            text: 'Деректер сатылмайды. Олар тек қызмет көрсету үшін төлем провайдеріне, eGov Mobile-ға және уәкілетті тұлғаларға берілуі мүмкін. Қолжетімділік шектелген, байланыс қорғалады.',
          },
          {
            title: '4. Пайдаланушы құқықтары',
            text: 'Пайдаланушы заңға қайшы келмесе, деректерді өңдеу туралы мәлімет, түзету немесе жоюды сұрай алады. Өтініш Кәсіпорынның байланыс арналарына жіберіледі.',
          },
        ],
      },
      {
        id: 'refund',
        title: 'Қызмет пен ақшаны қайтару тәртібі',
        sections: [
          {
            title: '1. Қызмет сипаты',
            text: 'Сервис — электрондық қызмет. Физикалық тауар берілмейді, бөлшек саудадағы тауарды қайтару қолданылмайды. Жазылымның пайдаланылмаған төлемі қайтарылады.',
          },
          {
            title: '2. Қайтаруды қалай мәлімдеу',
            text: 'Пайдаланушы өтінішті +7 700 131 30 25 телефоны немесе 2303@313.kz поштасы арқылы жібереді, ЖСН, төлем күні мен себебін көрсетеді. Кәсіпорын өтінішті 5 жұмыс күні ішінде қарайды.',
          },
          {
            title: '3. Ақшаны қайтару мерзімі',
            text: 'Пайдаланылмаған кезең үшін ақша сол картаға немесе төлем тәсіліне өтініш мақұлданғаннан кейін 10 жұмыс күні ішінде қайтарылады. Банк ұстаған комиссияны Кәсіпорын өтемейді.',
          },
        ],
      },
      {
        id: 'delivery',
        title: 'Қызметті ұсыну тәртібі мен мерзімі',
        sections: [
          {
            title: '1. Ұсыну тәсілі',
            text: 'Қызмет Сервис сайтындағы жүргізуші кабинетінде қашықтан беріледі. Тауарды физикалық жеткізу, курьер және пошта жөнелтімі жүргізілмейді.',
          },
          {
            title: '2. Мерзім',
            text: 'Қолжетімділік төлем расталғаннан кейін бірден ашылады. Жазылым бір күнтізбелік айға әрекет етеді. «Тікелей өзін-өзі жұмыспен қамтыған» тарифінде құжаттар саны шектелмейді.',
          },
        ],
      },
      {
        id: 'replace',
        title: 'Сапасыз қызмет кезіндегі ауыстыру тәртібі',
        sections: [
          {
            title: '1. Кемшілік',
            text: 'Кемшілік — төленген жазылым кезінде Кәсіпорын кінәсінен кабинетке кіре алмау, жазылымды төлей алмау немесе құжаттарға қол жеткізе алмау.',
          },
          {
            title: '2. Ауыстыру (қалпына келтіру)',
            text: 'Пайдаланушы өтініші бойынша Кәсіпорын қолжетімділікті 1 жұмыс күні ішінде қалпына келтіреді. Қалпына келтіру мүмкін болмаса, Пайдаланушы қайтару құжатындағы тәртіппен ақшаны қайтаруға құқылы.',
          },
        ],
      },
      {
        id: 'price',
        title: 'Қызмет құны, ҚҚС-ты қоса',
        sections: [
          {
            title: '1. Тариф',
            text: '«Тікелей өзін-өзі жұмыспен қамтыған» тарифі: айына 1 000 (бір мың) теңге. ҚҚС қолданылса, бағаға ҚҚС кіреді. Жеткізу шығыны жоқ. Құжаттар саны шектелмейді.',
          },
          {
            title: '2. Басқа төлемдер',
            text: 'Тариф шеңберінде кіру, құжаттарға қол қою және сақтау үшін қосымша ақы алынбайды. Пайдаланушы банкі өз комиссиясын ұстауы мүмкін — ол Сервис бағасына кірмейді.',
          },
        ],
      },
      {
        id: 'contacts',
        title: 'Кәсіпорынның мекенжайы мен телефондары',
        sections: [
          {
            title: '1. Кәсіпорын',
            text: 'Cashalot ЭДО. Сайт: https://edo.cashalot.kz. Жүргізуші кабинеті: https://edo.cashalot.kz/driver.',
          },
          {
            title: '2. Пошталық, заңды және нақты мекенжай',
            text: 'Қазақстан Республикасы, Алматы қ., Медеу ауданы, Митин көшесі, 4-үй.',
          },
          {
            title: '3. Байланыс телефондары',
            text: 'Телефон: +7 700 131 30 25. Пошта: 2303@313.kz. Telegram: https://t.me/cashalot_edo.',
          },
        ],
      },
    ],
    faq: [
      {
        q: 'Құжаттарға қалай қол қоямын?',
        a: '«Қол қоюға» қойындысын ашып, «Қол қою» батырмасын басыңыз. Қол қою eGov Mobile қосымшасында өтеді.',
      },
      {
        q: 'eGov Mobile ашылмайды',
        a: 'Сайтты Safari (iPhone) немесе Chrome-да ашыңыз. Telegram не Instagram ішіндегі браузерді қолданбаңыз.',
      },
      {
        q: 'Қол қойылған құжаттарды қайдан көремін?',
        a: '«Қол қойылған» қойындысында. Мәлімет пен PDF үшін карточканы басыңыз.',
      },
      {
        q: 'Құжатты қалай жүктеймін?',
        a: 'Құжат карточкасын ашып, «Жүктеу» батырмасын басыңыз.',
      },
      {
        q: 'Құжат мерзімі өтіп кетті — не істеймін?',
        a: 'Мүмкіндігінше тез қол қойыңыз. Болмаса техникалық қолдауға жазыңыз.',
      },
    ],
  },
} as const;

export type DriverCopy = (typeof COPY)[DriverLang];

export function formatMoney(value: number) {
  return new Intl.NumberFormat('ru-RU').format(Math.floor(value));
}

/** «Иван И.» из ФИО «Иванов Иван …» */
export function shortDisplayName(fio?: string | null) {
  const parts = String(fio || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0];
  const lastName = parts[0];
  const firstName = parts[1];
  const initial = lastName.charAt(0);
  return initial ? `${firstName} ${initial}.` : firstName;
}

export function workStatusLabel(t: DriverCopy, workStatus?: string | null, isSelfemployed?: boolean | null) {
  const raw = String(workStatus || '').toLowerCase();
  if (raw === 'working') return t.working;
  if (raw === 'not_working' || raw === 'not-working') return t.notWorking;
  if (raw === 'fired') return t.fired;
  if (isSelfemployed) return t.selfemployed;
  return t.active;
}
